import { CSSProperties, memo } from 'react'

import { getTicketScrollIndicatorState } from './lib/getTicketScrollIndicatorState'
import s from './styles.module.scss'

interface Props {
  activeIndex: number
  loadedCount: number
  totalCount?: number
  hasMorePages: boolean
}

interface TicketScrollIndicatorStyles extends CSSProperties {
  '--ticket-progress': string
  '--ticket-shift': string
  '--ticket-thumb-size': string
}

const TicketScrollIndicatorComponent = ({
  activeIndex,
  loadedCount,
  totalCount,
  hasMorePages,
}: Props) => {
  const { isVisible, progress, thumbRatio } = getTicketScrollIndicatorState({
    activeIndex,
    loadedCount,
    totalCount,
    hasMorePages,
  })

  if (!isVisible) return null

  const style: TicketScrollIndicatorStyles = {
    '--ticket-progress': `${progress * 100}%`,
    '--ticket-shift': `${progress * -100}%`,
    '--ticket-thumb-size': `${thumbRatio * 100}%`,
  }

  return (
    <div
      className={s.container}
      style={style}
      aria-hidden
    >
      <span className={s.track} />
      <span className={s.thumb} />
    </div>
  )
}

export const TicketScrollIndicator = memo(TicketScrollIndicatorComponent)
